export default {"src":"/_next/static/media/explorer.acb43eb3.svg","height":628,"width":628,"blurWidth":0,"blurHeight":0};